import { Violation, ViolationSeverity } from './../violation';
import { getPropertyRulesFor, updatePropertyRulesFor } from './utils';

export class LengthError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}

export function Length(args: { min?: number; max?: number }, message: string): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const propertyRules = getPropertyRulesFor(target, key);

        propertyRules.push([{
            async: false,
            violationType: LengthError.bind(null, message),
            validate: (context, { min = 0, max = Number.MAX_VALUE }) => {
                const value = context.source[key];
                if (typeof value === 'string') {
                    return value.length >= min && value.length <= max;
                }
                return true;
            }
        }, args]);

        updatePropertyRulesFor(target, key, propertyRules);
    };
}

export const ShortestLength = 16;

export const VeryShortLength = 32;
/**
 * 32
 */
export function VeryShortString(message: string): PropertyDecorator {
    return Length({ max: VeryShortLength }, message);
}

export const ShortLength = 64;
/**
 * 64
 */
export function ShortString(message: string): PropertyDecorator {
    return Length({ max: ShortLength }, message);
}

export const NormalLength = 128;
/**
 * 128
 */
export function NormalString(message: string): PropertyDecorator {
    return Length({ max: NormalLength }, message);
}

export const LongLength = 256;
/**
 * 256
 */
export function LongString(message: string): PropertyDecorator {
    return Length({ max: LongLength }, message);
}

export const VeryLongLength = 512;
/**
 * 512
 */
export function VeryLongString(message: string): PropertyDecorator {
    return Length({ max: VeryLongLength }, message);
}

export const MaxLength = 4000;
/**
 * 4000
 */
export function MaxString(message: string): PropertyDecorator {
    return Length({ max: MaxLength }, message);
}
